import Swiper from 'Swiper'

/**
 * HeatAndServeWhereToBuy component.
 * @author Dayne Coulson-Hoffacker
 */
export default class HeatAndServeWhereToBuy {
  /**
   * Constructs a new HeatAndServeWhereToBuy component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')
    this.swiperSlides = this.element.queryAll('.swiper-slide')

    // if (this.swiperSlides.length > 1) {
    //   this.element.classList.add('has-gallery')
    // }

    const slider = new Swiper(this.swiperContainer, {
      loop: true,
      slidesPerView: 5,
      spaceBetween: 60,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      breakpoints: {
        667: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 4
        }
      },
      pagination: {
        el: this.swiperPagination,
        type: 'progressbar',
        clickable: true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/heat-and-serve-where-to-buy/index.js